module.exports = __webpack_public_path__ + "img/wechat_icon.207a3836.svg";